import {  Avatar, Link } from "@chakra-ui/react";

function UserProfile() {


  return (
    <>
      <Link
        className="userProfile">
        
        <Avatar src="https://i.pravatar.cc/300?u=a042581f4e29026707d" borderRadius={4} h={"37.5px"} w={"37.5px"} alt="Profile picture" border={"1px solid"} borderColor={"transparent"} />

          
      </Link>

     
    </>
  );
}

export default UserProfile;